import React from 'react';
import {
    useTranslator,
    useUrlLocalizer,
    useCurrentLanguage
} from 'tradera-lang/translate';
import { isSwedishOrUndefined } from 'tradera-localization/languagecode';
import { HOVER_MENUS } from './hover-menu/constants';
import HoverMenu from './hover-menu/hover-menu';
import HoverMenuItem from './hover-menu/hover-menu-item';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';

export const HowTraderaWorks = ({
    mouseOut,
    mouseOver,
    onBlur,
    transparentHeader,
    showMenu
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const { language } = useCurrentLanguage();

    const isSwedish = isSwedishOrUndefined(language);

    return (
        <div
            onMouseLeave={mouseOut}
            onMouseEnter={() => mouseOver(HOVER_MENUS.HOW_TRADERA_WORKS)}>
            <a
                className={`btn slim-header__link-spacing px-md-2 px-lg-1 d-none d-md-flex align-items-center ${
                    transparentHeader
                        ? 'btn-transparent-header'
                        : 'btn-link-branded'
                } 
                    ${showMenu ? 'active' : ''}`}
                href={toLocalizedUrl('/how-to-buy')}>
                <InfoIcon className="icon icon-md d-block d-xl-none" />
                <span className="d-none d-xl-inline slim-header__link-text">
                    {t('siteHeader_howTo_v2')}
                </span>
            </a>
            <HoverMenu showMenu={showMenu}>
                <HoverMenuItem
                    onClick={onBlur}
                    label={t('siteHeader_howToBuy_v2')}
                    link={toLocalizedUrl('/how-to-buy')}
                    gaAttributes={{
                        'data-ga-category': 'Top navigation',
                        'data-ga-action': 'How to buy',
                        'data-ga-label': 'Link - How to buy'
                    }}
                />
                <HoverMenuItem
                    onClick={onBlur}
                    label={t('siteHeader_howToSell_v2')}
                    link={toLocalizedUrl('/how-to-sell')}
                    gaAttributes={{
                        'data-ga-category': 'Top navigation',
                        'data-ga-action': 'How to sell',
                        'data-ga-label': 'Link - How to sell'
                    }}
                />
                {isSwedish && (
                    <HoverMenuItem
                        onClick={onBlur}
                        label={t('siteHeader_howToSellCompany')}
                        link={'https://info.tradera.com/foretag/'}
                        gaAttributes={{
                            'data-ga-category': 'Top navigation',
                            'data-ga-action': 'How to sell company',
                            'data-ga-label': 'Link - How to sell company'
                        }}
                    />
                )}
            </HoverMenu>
        </div>
    );
};
